'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'reset_password_manager',
    modelClass: require('./model'),
    viewClass: require('./view'),

    methods: {
        setRecoverCode: function(hashParameters) {
            const params = Odigeo.Utils.parseHashParameters(hashParameters);

            this.model.hashCode = params.ac || '';

            if (params.cf === 'legacy') {
                this.model.isLegacy = true;
                this.setRecoverCode();
            }
        },

        passwordWithError: function() {
            this.passwordError('backerror');
        },

        passwordError: function() {
            this.passwordError('requestError');
        },

        passwordChangedOk: function() {
            this._trackEvent('recovery_successful_message');
            const $passwordChangedDialog = Odigeo.UIElements.createDialog({
                dialogClasses: 'od-login-reset-dialog',
                headerText: '<div class="od-login-icon-reset-pass-success"></div>',
                content: this.keys.loginChangePasswordChanged,
            });
            Odigeo.UIElements.showDialog($passwordChangedDialog);
            Odigeo._.delay(Odigeo._.bind(function() {
                Odigeo.Utils.goToApplicationHome();
            }, this), 1500);
        },
    },
});
